import UIButton from 'components/ui/form/UIButton';
import React from 'react';
import logo from 'assets/icons/logo.svg'
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from 'react-router-dom';
import UICard from 'components/ui/card/UICard';

const ErrorFallback = props => {
  const navigate = useNavigate();
  const { error, resetErrorBoundary } = props;

  const retryChecking = () => {
    resetErrorBoundary();
  }

  const navigateToDashboard = () => {
    navigate('/home/dashboard');
    window.location.reload();
  }

  return (
    <>
      <div className='centered-justified-no-page'>
        <div className="d-flex align-items-center">
          <img src={logo} alt="Enliv Logo" />&emsp;<span className='hxl text-primary'>ENLIV HEALTH</span>
        </div>
        <div className="b1-primary my-3">
          <UICard customClasses="b1-primary shadow-lg p-5 m-md-5" jsx CardBody={<>
            <p className='text-center mb-3'>
              <CancelIcon style={{ fontSize: 60 }} color='error' />
            </p>
            <p className='fs text-center'>
              Something went wrong while handling your request, please retry or<br />
              navigate to home.
            </p>
            <small className='fxs text-center'>
              <p>What went wrong?</p>
              <p className='text-danger'>{error?.message || ''}</p>
            </small>
          </>} />
        </div>
        <div className="d-inline gx-2">
          <UIButton callback={retryChecking} text="Retry" />&emsp;
          <UIButton callback={navigateToDashboard} text="Dashboard" />
        </div>
      </div>
    </>
  );
};

export default ErrorFallback;
